import { createRouteRef } from '@backstage/frontend-plugin-api';

/** Native RouteRef for the yaml-editor entity content tab. */
export const yamlEditorRouteRef = createRouteRef();

// Raw component for EntityContentBlueprint loader (not the RoutableExtension wrapper)
export { EntityYamlEditorContent as EntityYamlEditorPageContent } from './components/EntityYamlEditorContent';
